module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dropdown', _vm._b({}, 'el-dropdown', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f920442"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/dropdown/rtDropdown.vue
// module id = 1487
// module chunks = 91